export default __webpack_public_path__ + "static/media/cp_geo_tr.137555a8.svg";